import { createFileRoute } from '@tanstack/react-router'

import { equipmentRefsSamplesQuery } from '@/queries/equipment-refs-samples.query'
import { equipmentsWithSamplingsQuery } from '@/queries/equipments-with-samplings.query'

export const Route = createFileRoute('/_dashboard/site/$id/equipment/choose-sample/')({
  async loader({ params, context: { queryClient } }) {
    await queryClient.ensureQueryData(equipmentsWithSamplingsQuery(params.id, { action: 'show' }))
    await queryClient.ensureQueryData(equipmentRefsSamplesQuery)
  },
})
